const MessageStyle = {
  Warning: 'warning',
  Error: 'error',
};

export default MessageStyle;
